export default "__VITE_ASSET__CnWpF9vb__"